import React, { useState } from "react";
import "./styles/Contact.css";
import { MdEmail } from "react-icons/md";
import Colors from "../config/Colors";

const Contact = () => {
  const [isHovered, setIsHovered] = useState(false);

  function SendEmailButton() {
    const email = "trackmatesupport@gmail.com";
    const subject = "Support Request";
    const body = "Hi there,\n\nI need help on the following.\n\n";

    const gmailUrl = `https://mail.google.com/mail/?view=cm&fs=1&to=${encodeURIComponent(
      email
    )}&su=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;

    const handleClick = () => {
      window.open(gmailUrl, "_blank");
    };

    return (
      <button
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
        onClick={handleClick}
        style={{
          padding: "10px 20px",
          borderWidth: 0,
          width: "100%",
          borderRadius: 5,
          boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
          backgroundColor: isHovered ? Colors.grayColor : "white",
          color: "black",
          cursor: "pointer",
          justifyContent: "center",
          display: "flex",
        }}
      >
        Send Email
        <MdEmail style={{ marginLeft: "8px" }} />
      </button>
    );
  }

  return (
    <div className="contact-container">
      <h2>Contact Us</h2>
      <p>Email: trackmatesupport@gmail.com</p>
      <p>Available Hours: Monday to Saturday, 9 AM - 5 PM</p>

      <SendEmailButton />
    </div>
  );
};

export default Contact;
